import { newAlertify } from 'trunks/vue/admin/components/alert.js';
import LocationMixin from 'trunks/vue/share/components/fields/location.js';
import FieldMixinForResponse from './mixin.js';

const LocationForResponse = {
  mixins: [
    FieldMixinForResponse,
    LocationMixin
  ],

  template: `
    <Field :field='field'
           v-show='visible'
           :extendClass='[fieldCommonClass, fieldDifferenceClass]'
           :message='errorMsg'>
      <template slot='input'>
        <div class="form-field-value location-field">
          <div class="vertical-middle" v-if='value'>
            <i class="slp-map-marker"></i>
            <span>{{ value.value }}</span>
            <div class="destroy-btn">
              <i class="slp-minus-circle gray-text strong-text" @click='destroyValue' v-if='editing'></i>
            </div>
          </div>
          <div class="placeholder" v-if='!value && !editing'>未填写</div>
          <button class="btn-default btn-locate" @click='getLocation' v-if='editing && !value'>
            <span v-show='!locating'>点击定位</span>
            <i class="slp-map-marker" v-show='!locating'></i>
            <span v-show='locating'>{{ locatingText }}</span>
            <i v-show='locating' class="slp-loading spin"></i>
          </button>
        </div>
      </template>
    </Field>
  `,

  methods: {
    _alertError: function(errorMsg) {
      newAlertify(errorMsg, { type: 'error' });
    }
  }
};

export default LocationForResponse;
